export default __webpack_public_path__ + "files/thumbnail-87be271da81255ae912a58c45f50057e.png";